import {
  put,
  call,
  take,
  cancelled,
  cancel,
  fork,
} from "@redux-saga/core/effects";
import { REQUEST, FAILURE } from "../actions";
import * as authActions from "../actions/auth";
import { request } from "../../services/helpers";
import { handleErrors } from "./index";

export const adminLogin = ({ authKey, password }) => {
  return request.post("/admin/login", { authKey, password });
};

function* logout() {
  yield put(authActions.logout());
  localStorage.removeItem("token");
  // push to login page
}

function* login(authData, history) {
  try {
    const response = yield call(adminLogin, authData);
    yield put(authActions.adminLogin.success(response.data.token));
    localStorage.setItem("token", response.data.token);
    request.defaults.headers.common["token"] = response.data.token;
    history.push("/");
  } catch (e) {
    const error = handleErrors(e);
    yield put(authActions.adminLogin.failure(error));
  } finally {
    if (yield cancelled()) {
      // redirect to login page
      history.push("/login");
    }
  }
}

export function* authWatcher() {
  while (true) {
    const { payload } = yield take(authActions.ADMIN_LOGIN[REQUEST]);
    const task = yield fork(login, payload.data, payload.history);
    const action = yield take([
      authActions.LOGOUT,
      authActions.ADMIN_LOGIN[FAILURE],
    ]);
    if (action.type === authActions.LOGOUT) yield cancel(task);
    yield call(logout);
  }
}
